import { useMount } from "ahooks";
import { useState } from "react";
interface PROPS {
  dataSource: {
    title: string;
    href?: string;
    truncate?: boolean;
  }[];
}
const BreadCrumb = (props: PROPS) => {
  const { dataSource } = props;
  const [styleObj, setStyleObj] = useState({});
  useMount(() => {
    const ele = document.querySelector(".bread-crumb-content");
    const a = ele.getBoundingClientRect();
    setStyleObj({
      top: `${a.top}px`,
    });
  });
  return (
    <>
      <div
        className=" bread-crumb-content text-[14px] h-[46px] bg-white sticky pc:top-[32px] z-[100] "
        style={styleObj}
      >
        <div className=" max-w-[1200px] mx-auto flex h-[46px] items-center mo:px-[12px]">
          {dataSource.map((v, i) => {
            return (
              <div
                key={i}
                className={`whitespace-nowrap ${v.truncate ? "truncate" : ""}`}
              >
                {i > 0 && <span className="mx-[8px]">/</span>}
                {v.href ? (
                  <a href={v.href}>{v.title}</a>
                ) : (
                  <span>{v.title}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
export default BreadCrumb;
